export default __webpack_public_path__ + "static/menu-new-bg-a922372861897f5382d93abae3312b51.png";